
// 导入公用方法
export default {
  //获取导入状态样式
  getImportStateClass(importState) {
    if (!importState && importState !== 0) {
    return '-';
    }
    switch (importState) {
        // 导入成功
    case 0:
        return 'import-state import-state-success';
        break;
        //导入中
    case 1:
        return 'import-state import-state-hand';
        break;
        // 导入异常
    case -1:
        return 'import-state import-state-error';
        break;
    }
  },
  //批量删除禁用
  getDelSelected(importState){
    return importState !== 1 ? true : false;
  }
};